import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useGameHeader, HeaderBackButton } from '../../components/layout';
import { ContestDetailsPage } from '../../pages/contests/contest-details-page';

const ContestRouteComponent = () => {
  const { contestId } = Route.useParams();
  const navigate = useNavigate();
  const goBack = () => void navigate({ to: '/lobby' });

  useGameHeader({
    left: <HeaderBackButton onClick={goBack} />,
  });

  return <ContestDetailsPage contestId={contestId} onReturnToLobby={goBack} />;
};

export const Route = createFileRoute('/_authenticated/contest/$contestId')({
  component: ContestRouteComponent,
});
